import request from "./request";
/**
 * 增加授权
 * @param code FaceBook code
 */
export default async function addDataAuthorization(data) {
  return await request.post("/spin/dataBusiness/getBusinessByCode", data);
}
